/**
 * Schema of ConfigAlerta
 * @author Simpli CLI generator
 */
import {cnpj, cpf, Schema} from 'simpli-web-sdk'
import DeliveryDriverResponse from '@/model/response/DeliveryDriverResponse'
import RenderNumber from '@/components/render/RenderNumber.vue'

export default (model: DeliveryDriverResponse): Schema => ({

    nome: {
        content: model.nome || '',
    },
    documento: {
        content: cpf(model.documento) || '',
    },

    placa: {
        content: model.placa || '',
    },

  qtdSemOcorrencia: {
    content: {
      component: RenderNumber,
      props: {
        number: model.qtdSemOcorrencia,
      },
    },
    textContent: model.qtdSemOcorrencia || '0',

  },

  qtdComOcorrencia: {
    content: {
      component: RenderNumber,
      props: {
        number: model.qtdComOcorrencia,
      },
    },
    textContent: model.qtdComOcorrencia || '0',
  },

    qtdDevolvidas: {
        content: {
          component: RenderNumber,
          props: {
            number: model.qtdDevolvidas,
          },
        },
        textContent: model.qtdDevolvidas || '0',
    },

    qtdTotal: {
        content: {
            component: RenderNumber,
            props: {
                number: model.qtdTotal,
            },
        },
        textContent: model.qtdTotal || '0',
    },

})
